import React from 'react'
import PropTypes from 'prop-types'
import { CalendarIcon, CancelledIcon } from 'images'

const TableMessage = ({ variant = 'empty', title, description }) => {
  return (
    <div className={`table-message ${variant}`}>
      <div className="table-message__icon">
        {variant === 'empty' && <CalendarIcon />}
        {variant === 'error' && <CancelledIcon width={12} height={12} />} 
      </div>

      {title && <p className="table-message__title">{title}</p>}

      {description && <p className="table-message__description">{description}</p>}
    </div>
  )
}

TableMessage.propTypes = {
  variant: PropTypes.oneOf(['empty', 'error']),
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
}

export default TableMessage